import React from 'react';

import { Column, Row } from '@upgrade/react-components';
import { OfficeCard, OfficeText } from './styles';

import { Heading, Text } from '../common/TypographyPublicSite';
import Link from '../common/Link';
import { ResponsiveImage } from '../common/styles';

const Office = ({
  imgSrc,
  imgWidth,
  imgHeight,
  cityName,
  description,
  moreInfoText,
  moreInfoLink,
  moreInfoLinkAriaLabel
}) => {
  return (
    <OfficeCard>
      <ResponsiveImage src={imgSrc} width={imgWidth} height={imgHeight} />
      <OfficeText>
        <Row xsHorizontalAlign="start">
          <Column xs={12}>
            <Heading size="xs" marginBottom="sm" as="h2">
              {cityName}
            </Heading>
          </Column>
          <Column xs={12}>
            <Text color="contentWeak" as="p" marginBottom="sm">
              {description}
            </Text>
          </Column>
          <Column xs={12}>
            <Link to={moreInfoLink} ariaLabel={moreInfoLinkAriaLabel} openInNewWindow>
              {moreInfoText}
            </Link>
          </Column>
        </Row>
      </OfficeText>
    </OfficeCard>
  );
};

export default Office;
